export const flattenHierarchy = (nodes) => {
  let flat = [];
  nodes.forEach((node) => {
    flat.push({ id: node.id, name: node.name, parent_id: node.parent_id });
    if (node.children && node.children.length > 0) {
      flat = flat.concat(flattenHierarchy(node.children));
    }
  });
  return flat;
};
